import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OthersAppraisalEvaluate = () => {
  const { requestId } = useParams();
  const history = useHistory();

  const [data, setData] = useState(null);
  const [answers, setAnswers] = useState({});
  const [step, setStep] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/appraisal/evaluate/${requestId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => setData(res.data))
      .catch(() => toast.error("Failed to load appraisal"));
  }, [requestId]);

  if (!data) return <div>Loading...</div>;

  /* ================= VIEW MODE ================= */
  if (data.is_answerd === 1) {
    return (
      <div className="card">
        <ToastContainer position="top-right" autoClose={3000} />

        <div className="card-header d-flex justify-content-between">
          <h5>Others Appraisal Score</h5>
          <button
            className="btn btn-primary"
            onClick={() => history.push("/OthersAppraisalList")}
          >
            Back
          </button>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-md-7">
              <div className="p-3 bg-white">
                <h4>
                  Total Rating Score :
                  <span className="text-danger"> {data.score.total_score}</span>
                </h4>
                <h5>
                  Threshold :
                  <span className="text-primary"> {data.score.threshold}</span>
                </h5>
              </div>
            </div>

            <div className="col-md-5">
              <div className="p-3 bg-white">
                <h4>
                  Performance Bucket :
                  <span className="text-danger"> {data.score.grade}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ================= EVALUATE MODE ================= */
  const questions = data.questions;
  const current = questions[step];

  const info = data.info || {};
  const LOGO_URL = `${API_BASE_URL.replace("/api", "")}/uploads/logo/payroll/annai_arul_logo.jpg`;
  const profilePicUrl = info.profile_picture
    ? `${API_BASE_URL.replace("/api", "")}/uploads/profile/${info.profile_picture}`
    : LOGO_URL;

  /* ================= HELPERS ================= */
  const isAnswered = (questionId) => {
    return answers[questionId] !== undefined;
  };

  /* ================= SUBMIT ================= */
  const submit = () => {
    setSubmitting(true);

    axios
      .post(
        `${API_BASE_URL}/appraisal/evaluate/submit`,
        {
          request_id: requestId,
          employee_id: data.info.sent_to,
          answers: Object.values(answers),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.message || "Appraisal submitted successfully 🎉");
        setTimeout(() => {
          history.push("/OthersAppraisalList");
        }, 1500);
      })
      .catch(() => {
        toast.error("Submission failed. Please try again ❌");
        setSubmitting(false);
      });
  };

  return (
    <div className="card">
      <ToastContainer position="bottom-right" />

      {/* --- ADDED EMPLOYEE INFO HEADER --- */}
      <div className="card-header d-flex align-items-center justify-content-between bg-light">
        <div className="d-flex align-items-center">
          <img
            src={profilePicUrl}
            alt="Profile/Logo"
            style={{ width: "70px", height: "70px", objectFit: "cover", borderRadius: "50%", marginRight: "20px", border: "2px solid #ddd" }}
          />
          <div className="text-left" style={{ textAlign: "left" }}>
            <h6 className="mb-0 font-weight-bold">{info.employee_name || "Employee Name"}</h6>
            <small className="text-muted">{info.department_name || "Department"} {info.employee_id ? `| ${info.employee_id}` : ""}</small>
          </div>
        </div>
        <div>
          <button className="btn btn-sm btn-outline-secondary" onClick={() => history.push("/OthersAppraisalList")}>Back</button>
        </div>
      </div>

      <div className="card-header text-center">
        <h5>{current.question_title}</h5>
        <small>
          Question {step + 1} / {questions.length}
        </small>
      </div>

      <div className="card-body">
        {current.options.map((o) => (
          <div key={o.value_id} className="form-check mb-2">
            <input
              type="radio"
              className="form-check-input"
              name={`question_${current.question_id}`}
              checked={
                answers[current.question_id]?.option_id === o.value_id
              }
              onChange={() =>
                setAnswers({
                  ...answers,
                  [current.question_id]: {
                    question_id: current.question_id,
                    option_id: o.value_id,
                    score: o.score,
                  },
                })
              }
            />
            <label className="form-check-label">{o.value_title}</label>
          </div>
        ))}
      </div>

      <div className="card-footer d-flex justify-content-between">
        <button
          className="btn btn-secondary"
          disabled={step === 0}
          onClick={() => setStep(step - 1)}
        >
          Previous
        </button>

        {step < questions.length - 1 ? (
          <button
            className="btn btn-primary"
            onClick={() => {
              if (!isAnswered(current.question_id)) {
                toast.error("Kindly select any one option ⚠️");
                return;
              }
              setStep(step + 1);
            }}
          >
            Next
          </button>
        ) : (
          <button
            className="btn btn-danger"
            disabled={submitting}
            onClick={() => {
              if (!isAnswered(current.question_id)) {
                toast.error("Kindly select any one option ");
                return;
              }
              submit();
            }}
          >
            {submitting ? "Submitting..." : "Submit"}
          </button>
        )}
      </div>
    </div>
  );
};

export default OthersAppraisalEvaluate;
